"use strict";
// generated_funding_request.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: zod_1.z.string().describe('Credit facility slug'),
    description: zod_1.z.string().describe('Description'),
    fundingSubmissionComponentsArtifactSlug: zod_1.z
        .string()
        .optional()
        .describe('Use if passing known funding request amounts + target dates. Created funding request will automatically be submitted. CSV with 3 columns: "type" (i.e. funding request component type), "totalAmount", "targetFundingDate".'),
});
exports.nodeType = 'file_generatedFundingRequest';
exports.IntermediateRecordConfigSchema = zod_1.z.object({
    tapeDescription: zod_1.z.string(),
    lenderVerificationConfig: tape_builder_base_1.LenderVerificationConfigSchema.optional(),
    fundingSubmissionComponentsArtifactSlug: zod_1.z.string().optional(),
});
exports.artifactType = 'fundingRequest';
//# sourceMappingURL=types.js.map